import template from './version-list.html';
import controller from './version-list.controller';

let versionListComponent = {
  bindings: {},
  template,
  controller
};

export default versionListComponent;


// WEBPACK FOOTER //
// ./client/app/components/version/version-list.component.js